import * as CONSTANTS from '../modules/constants';

export function stickyHeader() {
    window.addEventListener('load', function() {
        const header = document.getElementById('siteHeader');
        const nav = document.getElementById('siteNav');
        const main = document.getElementById('main');

        let headerDimensions = header.offsetHeight - nav.offsetHeight;
        let lastScrollTop = 0;
        const mobileBreakpoint = CONSTANTS.MOBILE_BREAKPOINT + 0.1 + 'rem';

        function resetOffsets() {
            headerDimensions = header.offsetHeight - nav.offsetHeight;
        }

        function stickyDisplayHandler() {
            // only run on larger screens
            if (window.matchMedia('(min-width:' + mobileBreakpoint + ')').matches) {
                var currentPos = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

                if (header != null && header.classList.contains('campaign-header-js')) {
                    headerDimensions = header.offsetHeight;
                } else {
                    headerDimensions = header.offsetHeight - nav.offsetHeight;
                }

                let isAutomatedScroll = header.getAttribute('data-automated-scroll');

                // handle header sticky
                if (currentPos === 0) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        header.classList.add('sticky-show');
                        header.style.top = null;
                        header.classList.remove('sticky-top');
                        main.style.marginTop = null;

                        if (header.classList.contains('campaign-header-show')) {
                            header.classList.remove('campaign-header-show');
                        }
                    }
                } else if (currentPos > lastScrollTop && currentPos > headerDimensions) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        // downscroll code
                        if (isAutomatedScroll != null && isAutomatedScroll == 'false') {
                            header.classList.add('sticky-top');
                            header.classList.remove('sticky-show');
                            header.style.top = '-' + headerDimensions + 'px';
                            main.style.marginTop = header.offsetHeight.toString() + 'px';
                        }
                    }
                } else if (currentPos < lastScrollTop && currentPos > headerDimensions) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        // upscroll code
                        header.classList.add('sticky-show');
                        header.style.top = '0px';
                    }
                }

                // set current position to lastScrollTop
                lastScrollTop = currentPos;
            }
        }

        window.addEventListener('resize', () =>
            window.requestAnimationFrame(() => {
                stickyDisplayHandler();
            })
        );

        window.addEventListener('scroll', () =>
            window.requestAnimationFrame(() => {
                stickyDisplayHandler();
            })
        );
    });
}
